import React from 'react'

import { useTranslation } from 'react-i18next'

import { DataClassName } from '@/Data/const'
import { formatCount } from '@/utils/getEntityLabelKey'

interface KanbanHeaderProps {
  title: string
  probability: number
  price: string
  count: number
  dataClassName: string
}

export const KanbanHeader: React.FC<KanbanHeaderProps> = ({
  title,
  probability,
  price,
  count,
  dataClassName,
}) => {
  const { t } = useTranslation()
  return (
    <div className="list-kanban-head">
      <div className="card card-arrow arrow-end">
        <div className="d-flex mb-2">
          <div className="h4">{title}</div>
          <span className="ms-auto my-auto badge">
            {showProbability(dataClassName) && probability + '%'}
          </span>
        </div>
        <div className="d-flex">
          <span className="my-auto text-small">
            {showPrice(dataClassName) && price}
          </span>
          <span className="ms-auto my-auto badge bg-green">
            {formatCount(t, count, dataClassName)}
          </span>
        </div>
      </div>
    </div>
  )
}

const showProbability = (dataClassName: string) => {
  return dataClassName === DataClassName.OPPORTUNITY
}

const showPrice = (dataClassName: string) => {
  return dataClassName === DataClassName.OPPORTUNITY
}
